/**
 * The `AuthProvider` enum — the auth cone's highest-fan-in symbol.
 *
 * Carved out of `src/utils/auth/persistedAuthProvider.ts` rather than moved
 * with it (OpenSpec `monorepo-auth-package` · S1, design D2/D5). That file
 * also holds `getPersistedAuthProvider()`, which reads the redux-persist
 * `persist:root` slice through `src/utils/auth/readPersistedAuthSlice.ts` —
 * a file held back app-side **solely for persisted-key manifest hygiene**
 * (a pure path rename would regenerate `persistence-manifest.json`, and a
 * zero-diff manifest is this change's proof that no persisted-state owner
 * moved). The enum itself has no importer dependency on that tethered half,
 * which is exactly the extraction the `auth-package-delegates` spec permits.
 *
 * `src/utils/auth/persistedAuthProvider.ts` stays whole app-side and
 * re-exports this enum name-intact, so every existing importer and every
 * `jest.mock('@/utils/auth/persistedAuthProvider', …)` literal keeps
 * resolving unchanged.
 *
 * Intentionally dependency-free: it is imported from the pre-rehydration
 * paths and must never pull `authModel` (or anything else) in behind it.
 */
export enum AuthProvider {
  KINDE = 'KINDE',
  FHIR = 'FHIR',
  AUTH0 = 'AUTH0',
  AUTH0_DESKTOP = 'AUTH0_DESKTOP',
  /**
   * On-prem Keycloak (MOD-885). Set by `<KeycloakReduxSync>` when a
   * Keycloak session arrives, so logout / token-clear paths can branch
   * on it the same way they branch on KINDE / AUTH0.
   */
  KEYCLOAK = 'KEYCLOAK',
}
